// Registry of Atlas Map Quiz fixtures.
// POC: these definitions ship with the JS bundle and drive the whole quiz UI.
// No DB, no persistence, no Course → Unit → Lesson wiring.

import thirteenColonies from './thirteen_colonies';
import period2Empires from './period_2_empires';

export const SLUG_TO_QUIZ = {
  [thirteenColonies.slug]: thirteenColonies,
  [period2Empires.slug]: period2Empires,
};

export function getQuizBySlug(slug) {
  return SLUG_TO_QUIZ[slug] || null;
}

export const QUIZ_SLUGS = Object.keys(SLUG_TO_QUIZ);
